import { MouseEvent } from 'react'

const BOX_FILE_URL = /^https?:\/\/(?:[\w-]+\.)*box\.com\/file\/(\d+)(?:[/?#]|$)/i

/**
 * The Box file id behind a durable `https://<sub>.box.com/file/<id>` link, or null for
 * anything else. Folder links and `/s/<key>` shared links stay null on purpose: a shared
 * link can name a folder, and the preview drawer can only render files.
 */
export const getBoxFileId = (link?: string | null): string | null =>
  link?.match(BOX_FILE_URL)?.[1] ?? null

/** Modifier and non-primary clicks keep the browser's own behaviour: open the href. */
export const isModifierClick = (event: MouseEvent): boolean =>
  event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0
